import React, {useState, useRef} from 'react';
import {useContext, createContext, useEffect } from 'react';
import Finish from '../Pages/Finish';
export const CorrectContext = React.createContext();
export default function Correct(countCorrect) {
    console.log("correct passed in: ", countCorrect);
    sessionStorage.setItem('thisRoundCorrect', JSON.stringify(countCorrect));
    return (
        <CorrectContext.Provider value={countCorrect}>
          <Finish />
        </CorrectContext.Provider>
      )
}


